<template>
  <el-dialog
    title="选择城市"
    :visible.sync="cityShow"
    width="70%"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
	:before-close="beforeClose"
  >
    <div class="top-box">
      <div class="serch">
        <span>直接搜索</span>
        <el-select v-model="searchValue" @change="changeSelect" filterable placeholder="请选择">
          <el-option
            v-for="item in serchData"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
	<div class="content-box">
		<div class="title">热门城市</div>
		<div class="c_box">
			<div class="item" v-for="item in getHotCity" @click="sureClick(item)" :key="item.locationId">{{item.nameCn}}</div>
		</div>
		<div class="title title-box">
			<div>按字母选择：</div>
			<div>
				<span class="zimu" @click="ziClick(index)" v-for="(item,index) in getCityCategory" :key="index">{{index}}</span>
			</div>
			
		</div>
		<div class="scroll-box">
		<template v-for="(item,index) in getCityCategory">
		<div class="list" :id="'c'+index"  v-if="item.length" :key="index">
				<div class="left_zimu">{{index}}</div>
				<div>
					<span v-for="ch in item" @click="sureClick(ch)" class="l_city" :key="ch.id">{{ch.nameCn}}</span>
				</div>
		</div>
		</template>
		</div>
	</div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    cityShow: {
      type: Boolean,
      default: true
    },
    cityDataList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    serchData() {
      return this.cityDataList.map((item) => {
        item.value = item.locationId
        item.label = item.nameCn
        return item
      })
    },
    //获取热门城市
    getHotCity() {
      return this.cityDataList.filter((item) => {
        return item.isHot
      })
    },
    //获取字母城市分类
    getCityCategory() {
      var lists = {
        A: [],
        B: [],
        C: [],
        D: [],
        E: [],
        F: [],
        G: [],
        H: [],
        I: [],
        J: [],
        K: [],
        L: [],
        M: [],
        N: [],
        O: [],
        P: [],
        Q: [],
        R: [],
        S: [],
        T: [],
        U: [],
        V: [],
        W: [],
        X: [],
        Y: [],
        Z: []
      }
      this.cityDataList.forEach((item) => {
        var s = item.namePinyin.substr(0, 1)
        s = s.toUpperCase()
        lists[s].push(item)
      })
      console.log('lists', lists)
      return lists
    }
  },
  data() {
    return {
      searchValue: '',
      crrentItem: null
    }
  },
  methods: {
    ziClick(i) {
      let a = 'c' + i
      document.getElementById(a).scrollIntoView({
        behavior: 'smooth' // 平滑滚动效果
      })
    },
    sureClick(item) {
      this.crrentItem = item
      this.$emit('adressCity', item)
      this.searchValue = ''
      //   this.cityShow=false
    },
    changeSelect(val) {
      console.log(val, 'val')
      let items = this.cityDataList.find((item) => item.value == val)
      this.crrentItem = items
      this.sureClick(items)
    },
    beforeClose() {
      console.log('this.crrentItem', this.crrentItem)
      this.$emit('beforeClose', false)
    }
  }
}
</script>

<style  lang="scss" scoped>
// /deep/.el-dialog__close {
//   display: none !important;
// }
// /deep/.el-dialog__header {
//   display: none !important;
// }
.top-box {
  height: 80px;
  .serch {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    span {
      display: inline-block;
      margin-right: 10px;
    }
  }
}
.content-box {
  .title {
    font-weight: 600;
  }
  .c_box {
    margin-top: 20px;
    .item {
      display: inline-block;
      padding: 10px 20px;
      box-sizing: border-box;
      background: #f8f8f8;
      border-radius: 4px;
      margin: 6px 3px;
      cursor: pointer;
    }
  }
  .title-box {
    display: flex;
    margin-top: 40px;
    .zimu {
      display: inline-block;
      width: 30px;
      text-align: center;
      cursor: pointer;
    }
  }
  .scroll-box {
    max-height: 300px;
    overflow: hidden;
    overflow-y: auto;
    margin-top: 30px;
    .list {
      display: flex;
      align-items: start;
      padding-left: 10px;
      .l_city {
        display: inline-block;
        padding: 10px 10px;
        box-sizing: border-box;
        border-radius: 4px;
        margin: 6px 3px;
        cursor: pointer;
        &:hover {
          font-weight: bold;
        }
      }
      .left_zimu {
        padding-top: 14px;
        font-size: 18px;
      }
      &:hover {
        background: #f8f8f8;
      }
    }
  }
}
</style>
